import styled from 'styled-components';

const Label = styled.label`
  text-transform: capitalize;
  font-weight: bold;
`;

export default Label;
